import React, { ComponentProps } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Text } from 'components/Text'
import {
  HeroRoot,
  ImageWrapper,
  BadgeContainer,
  HeroContent,
  IconContainer,
  FeatureColumn,
  HeroContainer,
  FeatureRow,
  SectionTitle,
  HeroHeader,
  SectionSubtitle,
  MobileFeatures,
} from './RecipeHero.styles'
import Image from 'next/image'
import hero from '../../../../../public/assets/recipes-hero.png'
import badge from '../../../../../public/assets/badge-3-red.svg'
import noPreservatives from '../../../../../public/assets/recipes/categories/no-preservatives.png'
import humanelyHarvested from '../../../../../public/assets/recipes/categories/humanely-harvested.png'
import noAddedAntibiotics from '../../../../../public/assets/recipes/categories/no-added-antibiotics.png'
import noFiller from '../../../../../public/assets/recipes/categories/no-filler.png'
import { Link } from '../../../../components/Link'
import Trans from 'next-translate/Trans'
import { ColorTokens } from 'stitches.config'
import { Button } from 'components/Button'

export type RecipeHeroProps = {
  background: ColorTokens;
  ctaText: string;
  order?: '0' | '1';
  ctaLink: string;
}

export const RecipeHero = (_props: RecipeHeroProps) => {
  const { t } = useTranslation()

  const { background, ctaText, order = '0', ctaLink } = _props

  const Features = () => {
    return (
      <>
        <FeatureColumn order={order}>
          <IconContainer type="filler">
            <Image src={noFiller} alt={t('recipes:overview.hero.feat-1.img')} layout="fill" />
          </IconContainer>
          <Text size={{"@initial":"body", "@bp2": "body"}} align="center" color="accent-black">
            <Trans components={{ br: <br /> }} i18nKey={'recipes:overview.hero.feat-1.title'} />
          </Text>
        </FeatureColumn>
        <FeatureColumn order={order}>
          <IconContainer type="preservatives">
            <Image src={noPreservatives} alt={t('recipes:overview.hero.feat-2.img')} layout="fill" />
          </IconContainer>
          <Text size={{"@initial":"body", "@bp2": "body"}} align="center" color="accent-black">
            <Trans components={{ br: <br /> }} i18nKey={'recipes:overview.hero.feat-2.title'} />
          </Text>
        </FeatureColumn>
        <FeatureColumn order={order}>
          <IconContainer type="humanely">
            <Image src={humanelyHarvested} alt={t('recipes:overview.hero.feat-3.img')} layout="fill" />
          </IconContainer>
          <Text size={{"@initial":"body", "@bp2": "body"}} align="center" color="accent-black">
            <Trans components={{ br: <br /> }} i18nKey={'recipes:overview.hero.feat-3.title'} />
          </Text>
        </FeatureColumn>
        <FeatureColumn order={order}>
          <IconContainer type="antibiotics">
            <Image src={noAddedAntibiotics} alt={t('recipes:overview.hero.feat-4.img')} layout="fill" />
          </IconContainer>
          <Text size={{"@initial":"body", "@bp2": "body"}} align="center" color="accent-black">
            <Trans components={{ br: <br /> }} i18nKey={'recipes:overview.hero.feat-4.title'} />
          </Text>
        </FeatureColumn>
      </>
    )
  }

  return (
    <HeroRoot css={{background: `$${background}`}}>
      <HeroContainer order={order}>
        <HeroContent order={order}>
          <BadgeContainer order={order} className='desktop-only'>
            <Image src={badge} alt={t('recipes:overview.hero.badge')} layout="fill" />
          </BadgeContainer>
          <HeroHeader order={order}>
            <SectionTitle>{t('recipes:overview.hero.title')}</SectionTitle>
            <SectionSubtitle
              size={{ '@initial': 'body', '@bp4': 'bodyExtraLarge' }}
              weight="regular"
              color="accent-black"
              align="center"
            >
              {t('recipes:overview.hero.description')}
            </SectionSubtitle>
          </HeroHeader>
          <Link href={ctaLink} passHref>
            <Button>{ctaText}</Button>
          </Link>
          <FeatureRow>
            <Features />
          </FeatureRow>
        </HeroContent>
        <ImageWrapper order={order}>
          <Image src={hero} alt="" />
          <BadgeContainer order={order} className='mobile-only'>
            <Image src={badge} alt={t('recipes:overview.hero.badge')} layout="fill" />
          </BadgeContainer>
        </ImageWrapper>
      </HeroContainer>
      <MobileFeatures>
        <Features />
      </MobileFeatures>
    </HeroRoot>
  )
}

RecipeHero.displayName = 'RecipeHero'
